/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:38:27
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
export declare namespace MaintenanceStaticDOI {
    export interface RowDataI {
        count: number
        site_name: string
        [str: string]: any
    }

    export interface QueryRowDataParamsI extends PageDo {
        site_name?: string;
        end_time?: Integer;
        start_time?: Integer;
    }

    export interface QueryDetailResultI {}

    export interface OperateParamsI {}
}
export default class MaintenanceStaticApi {
    /**
     * 查询列表
     * @param {MaintenanceStaticDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(
        params: MaintenanceStaticDOI.QueryRowDataParamsI,
    ): Promise<ResultPageDo<MaintenanceStaticDOI.RowDataI[], { key: string; name: string }[]>> {
        return Api.post('/ops/count/list/get', {
            site_name: '',
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date()),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date('1990')),
            ...params,
        });
    }
}
